import React from "react"

const Separator = ({style}) => (
    <div style={{height:2, borderBottom: "1px solid #cecece", width:'100%', ...style}}>

    </div>
)

export default Separator